/* eslint-disable no-console */

import { register } from 'register-service-worker'

let isRefreshing = false

const activateWaitingWorker = (registration) => {
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  }
}

const checkForUpdate = (registration) => {
  registration.update().catch((error) => {
    console.warn('Could not check for a service worker update:', error)
  })
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (isRefreshing) return
    isRefreshing = true
    window.location.reload()
  })
}

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: {
      updateViaCache: 'none'
    },
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      checkForUpdate(registration)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; refreshing...')
      activateWaitingWorker(registration)
      if (registration && registration.installing) {
        registration.installing.addEventListener('statechange', (event) => {
          const serviceWorker = event.target
          if (serviceWorker && serviceWorker.state === 'installed' && registration.waiting) {
            activateWaitingWorker(registration)
          }
        })
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
